import {createContext,useState,useEffect,useContext} from 'react';
import {useKeycloak} from "@react-keycloak/web";
import {useSnackbar} from '../../custom/components/SnackbarContext.js';
import {useLoading} from '../../custom/components/LoadingContext.js';
import {listPreDefaultFilter,listPreDefaultSorting} from '../../custom/entities/Lists.js';
import {getServerVariables} from '../../core/integration/Api.js'
import {consoleLog} from '../../core/utilities/Utilities.js';
const ApplicationContext=createContext();

const getLocaleFromGlobalData=(globalData,key)=>{
    if(!globalData||!globalData.lang){
        return "MISSING_LANG_IN_GLOBAL_DATA";
    }
    const strings=globalData.strings;
    if(!strings||!(key in strings)){
        return `MISSING_${key}_IN_STRINGS`;
    }
    return strings[key];
};

export const useApplication=()=>useContext(ApplicationContext);
const file='ApplicationContext.js';

export const ApplicationProvider=({children,userData})=>{
    const [globalData,setGlobalData]=useState(null);
    const {keycloak}=useKeycloak();
    const {showLoading,hideLoading}=useLoading();
    const {showSnackbar}=useSnackbar();

    const updateGlobalData=(newValue)=>{
        if(globalData.lang!==newValue.lang){
            newValue.filterModel={};
            for(const list in listPreDefaultFilter(newValue)){
                newValue.filterModel[list]=listPreDefaultFilter(newValue)[list];
            }
        }
        document.cookie="preferredLanguage="+encodeURIComponent(newValue.lang)+"; path=/; max-age=31536000; SameSite=Lax; Secure";
        setGlobalData(newValue);
    };

    useEffect(()=>{
        const handleStorage=(event)=>{
            if(event.key==='refresh_browser_at'){
                window.location.reload();
            }
        };
        window.addEventListener('storage',handleStorage);
        return()=>{
            window.removeEventListener('storage',handleStorage);
        };
    },[]);

    useEffect(()=>{
        if(keycloak.authenticated&&Object.keys(userData).length>0){
            showLoading();
            getServerVariables().then((data)=>{
                consoleLog({file:file,context:'useEffect - getServerVariables',arg_name:'data',arg_value:data});
                if('error' in data){
                    showSnackbar(data.error,'error');
                }
                else{
                    let globalObject={
                        lang:keycloak?.tokenParsed?.locale||"en",
                        locale:keycloak?.tokenParsed?.app_locale||"en",
                        email:keycloak?.tokenParsed?.email,
                        strings:data.strings,
                        list_of_values:data.list_of_values,
                        list_of_values_reverse:data.list_of_values_reverse,
                        countries:data.countries,
                        model_to_table_mapping:data.model_to_table_mapping,
                        table_to_model_mapping:data.table_to_model_mapping,
                        custom_parameters:data.custom_parameters,
                        env:data.env||"DEV",
                        dataGridParams:userData.datagrid_params||{},
                        getLocale:(key,options={})=>{return getLocaleFromGlobalData(globalObject,key,options.lang);}};
                    document.cookie="preferredLanguage="+encodeURIComponent(globalObject.lang)+"; path=/; max-age=31536000; SameSite=Lax; Secure";
                    globalObject.filterModel={};
                    for(const list in listPreDefaultFilter(globalObject)){
                        globalObject.filterModel[list]=listPreDefaultFilter(globalObject)[list];
                    }
                    globalObject.sortModel={};
                    for(const list in listPreDefaultSorting){
                        globalObject.sortModel[list]=listPreDefaultSorting[list];
                    }

                    (globalObject).getLocale=(key,options={})=>{return getLocaleFromGlobalData(globalObject,key,options.lang);};
                    consoleLog({file:file,context:'useEffect - getServerVariables',arg_name:'globalObject',arg_value:globalObject});
                    setGlobalData(old=>globalObject);
                }
                hideLoading();
            });      
        }
        // dependencies showLoading, hideLoading, showSnackbar and keycloak are stable
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[keycloak,userData]);

    return(
        <ApplicationContext.Provider value={{globalData,updateGlobalData}}>
            {children}
        </ApplicationContext.Provider>
    );
};